import PropTypes from 'prop-types'
import React from 'react'

import { scrollToBlock } from 'utils/client/scroll'

const ScrollToMe = ({ menuNode, ...props }) => {
  const divRef = React.useRef()

  React.useEffect(() => {
    divRef.current && scrollToBlock(divRef, menuNode)
  }, [menuNode])

  return <div {...props} ref={divRef} />
}

ScrollToMe.propTypes = {
  menuNode: PropTypes.object.isRequired,
}

export default ScrollToMe
